import { useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { stratSendSMS, setEsperandoSMS } from "../../../../context/actions/capturaActions";

export const useWhatsAppUbicacion = () => {
  const dispatch = useDispatch();
  const pollingIntervalRef = useRef(null);
  const { esperandoSMS, newLatLng } = useSelector((state) => state.asistenciasReducer);

  const enviarWhatsApp = useCallback(async () => {
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
      pollingIntervalRef.current = null;
    }
    const intervalID = await dispatch(stratSendSMS());
    pollingIntervalRef.current = intervalID;
  }, [dispatch]);

  useEffect(() => {
    return () => {
      if (pollingIntervalRef.current) clearInterval(pollingIntervalRef.current);
      dispatch(setEsperandoSMS(0));
    };
  }, [dispatch]);

  return {
    enviarWhatsApp,
    esperandoSMS,
    coordenadas: newLatLng,
  };
};
